<template>
  <pf-content v-if="prezzo > 0" v-bind="ouiaProps">
    <template v-if="title">{{ title }}: </template>
    <s v-if="wizard.fatturaMe && prezzo !== prezzoScontato">{{ $currency(prezzo, wizard.customer?.currency) }}</s>
    {{ ' ' }}
    <strong :class="{ 'pf-v6-u-font-size-xl': big }">{{ $currency(prezzoScontato, wizard.customer?.currency) }}</strong>
    <span class="vat" v-if="wizard.customer === undefined || wizard.customer.vat > 0"> + {{ $t('IVA') }}/ {{ durataLabel }}</span>
  </pf-content>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { $t as _t } from '../../../i18n';
import { useWizard } from '@/wizard';
import { type PRODOTTIANAGRAFICA_DURATA } from '../../../common/consts';

defineOptions({
  name: 'WizardSummaryTotals',
});

const props = defineProps<
  OUIAProps & {
    durata: (typeof PRODOTTIANAGRAFICA_DURATA)[number];
    gruppo: string;
    title?: string;
    big?: boolean;
  }
>();
const ouiaProps = useOUIAProps(props);

const wizard = useWizard();

const durataLabel = computed(() => (props.durata === 'Mensile' ? _t('Mese') : props.durata === 'Annuale' ? _t('Anno') : _t('Una tantum')));

const prezzo = computed(() => wizard.totaleSingoloWizardByDurata(props.durata, false, props.gruppo));
const prezzoScontato = computed(() => wizard.totaleSingoloWizardByDurata(props.durata, true, props.gruppo));
</script>
